import { LoadingButton } from "@mui/lab";
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProductOfferThunk,
  getOffersForProductThunk,
  productOfferSelector,
} from "store/reducers/product/productOffersSlice";

const OfferList = ({ product_id }) => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  useEffect(() => {
    dispatch(getOffersForProductThunk(product_id));
  }, [product_id]);
  const offers = useSelector(productOfferSelector.selectAll).filter(
    (item) => item.product === product_id
  );
  const removeOffer = (id) => {
    dispatch(deleteProductOfferThunk(id));
  };
  const { loading } = useSelector((state) => state.productOffer);
  return (
    <Box>
      {offers.length > 0 && (
        <>
          <Box
            component={Typography}
            variant="h4"
            sx={{ textDecoration: "underline", color: "text.secondary", mb: 1 }}
          >
            Available offers
          </Box>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box
                sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
                padding={1}
              >
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ minWidth: 150 }}>
                          {isSmallScreen ? "Name" : "Offer name"}
                        </TableCell>
                        <TableCell align="center" sx={{ minWidth: 120 }}>
                          {isSmallScreen ? "Desc" : "Offer description"}
                        </TableCell>
                        <TableCell align="center">
                          {isSmallScreen ? "Percentage" : "Offer percentage"}
                        </TableCell>
                        <TableCell align="center" sx={{ minWidth: 120 }}>
                          {isSmallScreen ? "From" : "From date"}
                        </TableCell>
                        <TableCell align="center" sx={{ minWidth: 120 }}>
                          {isSmallScreen ? "To" : "To date"}
                        </TableCell>
                        <TableCell align="center" sx={{ minWidth: 120 }}>
                          Status
                        </TableCell>
                        <TableCell>&nbsp;</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {offers.map((offer) => (
                        <TableRow
                          key={offer.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {offer.name}
                          </TableCell>
                          <TableCell align="center">{offer.desc}</TableCell>
                          <TableCell align="center">
                            {offer.offer_percentage} %
                          </TableCell>
                          <TableCell align="center">
                            {offer.offer_from_date}
                          </TableCell>
                          <TableCell align="center">
                            {offer.offer_to_date}
                          </TableCell>
                          <TableCell align="center">
                            {offer.expired ? (
                              <span style={{ color: "red" }}>Expired </span>
                            ) : (
                              <span style={{ color: "green" }}>Active </span>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <LoadingButton
                              variant="outlined"
                              color="error"
                              onClick={() => {
                                removeOffer(offer.id);
                              }}
                              loading={loading.delete === offer.id}
                            >
                              Delete
                            </LoadingButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default OfferList;
